export default {
    title: 'Fórum Astrolink',
    subtitle: 'Converse, aprenda e conheça pessoas',
    buttonAllTopics: 'Ver todos os tópicos',
    buttonCreateTopic: 'Criar novo tópico',
    messageWithoutTopic: 'Nenhum tópico criado até momento!',
    by: 'por',
    answer: 'resposta',
    answers: 'respostas',
    toAnswer: 'Responder',
    errorMessage: 'Não foi possível carregar os tópicos',
    topicsMine: 'Meus Tópicos',
    topicsOf: 'Tópicos de {name}',
    answeredTime: 'Última resposta {time}',
    topicsDescription: 'Veja os tópicos mais recentes'
}